import { Information } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

import IconButtonWithPopover from "../../../../../../components/buttons/IconButtonWithPopover/IconButtonWithPopover";
import { InboundDeliveryItemFragment } from "../../../../../../models/autogenerated-deliveryService-gql/graphql";
import DetailsPopoverItemHandlingUnit from "./detailsPopoverItems/DetailsPopoverItemHandlingUnit";
import DetailsPopoverItemMaterial from "./detailsPopoverItems/DetailsPopoverItemMaterial";

interface InfoButtonWithPopoverProps {
  detailsItem: InboundDeliveryItemFragment;
  className?: string;
}

const InfoButtonWithPopover = (props: InfoButtonWithPopoverProps) => {
  const { t } = useTranslation();
  const { detailsItem, className } = props;

  const renderPopoverBody = () => {
    switch (detailsItem.__typename) {
      case "MaterialItem":
        return <DetailsPopoverItemMaterial item={detailsItem} />;
      case "HandlingUnitItem":
        return <DetailsPopoverItemHandlingUnit item={detailsItem} />;
      default:
        return <></>;
    }
  };

  return (
    <IconButtonWithPopover
      title={t(detailsItem.__typename || "")}
      buttonIcon={<Information size={24} />}
      className={className}
    >
      {renderPopoverBody()}
    </IconButtonWithPopover>
  );
};
export default InfoButtonWithPopover;
